import { lazyLoadGoogleMaps } from "@shared/v2/widgets/googleMapsWidget";
import { i18n } from "@lib/i18n";
import { toast } from "@lib/reactToastify";

export const calculateDistanceInMetersSync = (maps, positionA, positionB) => {
  const a = new maps.LatLng(positionA);
  const b = new maps.LatLng(positionB);

  return Math.round(maps.geometry.spherical.computeDistanceBetween(a, b));
};

export const calculateDistanceInMetersAsync = async (positionA, positionB) => {
  try {
    const maps = await lazyLoadGoogleMaps(i18n.language);

    return calculateDistanceInMetersSync(maps, positionA, positionB);
  } catch (error) {
    toast.error(
      i18n.t("notify.apiDefaultError"),
      {
        toastId: "google-maps-load-error",
      },
      error
    );
  }
};
